import Vue from 'vue';
import VueRouter from 'vue-router';
import VueAnalytics from 'vue-analytics';
import VueAppInsights from 'vue-application-insights';
import policies from 'policies';
import routes from 'routes';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'open active',
  hashbang: false,
  root: '/',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return {
      x: 0,
      y: 0
    };
  },
  routes
});

if (process.env.NODE_ENV === 'production') {
  Vue.use(VueAppInsights, {
    id: process.env.APP_INSIGHTS_INSTR_KEY,
    router
  });

  Vue.use(VueAnalytics, {
    id: process.env.GOOGLE_ANALYTICS_ID,
    router
  });
}

router.beforeEach((to, from, next) => {
  const pageTitle = to.meta.label;
  const checkPageTitle = pageTitle ? `| ${pageTitle}` : '';
  document.title = `${process.env.APP_NAME} ${checkPageTitle}`;

  if (to.name === '500') return next();

  if (to.matched.some(m => m.meta.requiresAuth)) {
    policies.checkAuthAndRole(to, from, next);
  } else {
    next();
  }
});

// After navigation is confirmed, but before resolving...
router.beforeResolve((to, from, next) => {
  next();
});

export { router as default };
